import React, { useState, useEffect } from 'react';
import Spin from 'antd/lib/spin';
import { useParams } from 'react-router-dom';
import { getEventsList, getEventFilterOptions, getAlertResolutionsList } from '../../../../API';
import { ActiveAlertsTable } from './components/ActiveAlertsTable';
import { ResolvedAlertsTable } from './components/ResolvedAlertsTable';
import { config } from '../../../../config';

import { CheckmarkIcon } from '../CheckmarkIcon';

import './AlertsOverview.less';

const { REACT_APP_BUILD_ENV } = config;

export const AlertsOverview = (props) => {
  const { theme } = props;
  const { building } = useParams();
  const [activeEvents, setActiveEvents] = useState([]);
  const [resolvedEvents, setResolvedEvents] = useState([]);
  const [filterOptions, setFilterOptions] = useState([]);
  const [resolutionOptions, setResolutionOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    setIsLoading(true);
    const filterOptionsFromApi = await getEventFilterOptions(REACT_APP_BUILD_ENV, building);
    const resolutionOptionsFromApi = await getAlertResolutionsList(REACT_APP_BUILD_ENV, false);
    const activeEventsFromApi = await getEventsList(REACT_APP_BUILD_ENV, building, { is_resolved: false });
    const resolvedEventsFromApi = await getEventsList(REACT_APP_BUILD_ENV, building, { is_resolved: true });
    setFilterOptions(filterOptionsFromApi);
    setResolutionOptions(resolutionOptionsFromApi);
    setActiveEvents(activeEventsFromApi.results);
    setResolvedEvents(resolvedEventsFromApi.results);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [building]);

  const renderAlerts = () => {
    return (
      <>
        {!activeEvents.length ? (
          <div className="alerts-overview-no-active-alerts">
            <div className="alerts-overview-no-active-alerts-icon">
              <CheckmarkIcon theme="green" />
            </div>
            <div className="alerts-overview-no-active-alerts-content">
              <div className="alerts-overview-no-active-alerts-title">
                <strong>Good news!</strong>
                <span>Nothing needs your attention right now.</span>
              </div>
              <span>We will alert you when there are problems happening with your building!</span>
            </div>
          </div>
        ) : (
          <ActiveAlertsTable
            activeEvents={activeEvents}
            updateActiveEvents={(updatedEvents) => setActiveEvents(updatedEvents)}
            theme={theme}
          />
        )}
        <ResolvedAlertsTable
          resolvedEvents={resolvedEvents}
          updateResolvedEvents={(updatedEvents) => setResolvedEvents(updatedEvents)}
          filterOptions={filterOptions}
          resolutionOptions={resolutionOptions}
          theme={theme}
        />
      </>
    );
  };

  return (
    <div className={`alerts-overview-wrapper alerts-overview-wrapper-${theme}`}>
      {isLoading ? <Spin /> : renderAlerts()}
    </div>
  );
};
